import { usePapaParse } from "react-papaparse";
const ExportFile = (exportData) => {
  const { jsonToCSV } = usePapaParse();
  const results = jsonToCSV(exportData);
  return results;
};
export default ExportFile;
